
define('tpl!ui/generis/widget/hiddenBox/hiddenBox', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); partials = this.merge(partials, Handlebars.partials); data = data || {};
  var buffer = "", stack1, helper, self=this, functionType="function", escapeExpression=this.escapeExpression;


  buffer += "<div class=\"ui-generis-widget hidden-box\">\n    <div class=\"left\">\n        ";
  stack1 = self.invokePartial(partials['ui-generis-widget-label'], 'ui-generis-widget-label', depth0, helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </div>\n    <div class=\"right\">\n        <input name=\"";
  if (helper = helpers.uri) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.uri); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" type=\"password\">\n    </div>\n</div>\n\n<div class=\"ui-generis-widget hidden-box confirmation\">\n    <div class=\"left\">\n        ";
  stack1 = self.invokePartial(partials['ui-generis-widget-label'], 'ui-generis-widget-label', (depth0 && depth0.confirmation), helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </div>\n    <div class=\"right\">\n        <input name=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.confirmation)),stack1 == null || stack1 === false ? stack1 : stack1.uri)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\" type=\"password\">\n    </div>\n</div>";
  return buffer;
  });
});

